import { HelpCircle } from "lucide-react";
import PageHeader from "../ui/PageHeader";

export default function AideEnLigne() {
  return (
    <div className="w-full h-screen p-6 bg-white rounded-lg shadow-sm text-left">
      <PageHeader
      icon={HelpCircle}
      title="Aide en ligne"
      description="Retrouvez ici toutes les réponses à vos questions concernant l'utilisation de la plateforme. 
        Consultez nos guides, découvrez les fonctionnalités et bénéficiez d’un accompagnement pour optimiser votre expérience."
    />
    </div>
  );
}
